import React, { FC } from 'react';
import { ToggleNotSelectedElement } from './ToggleNotSelectedElement';
import { ToggleSelectedElement } from './ToggleSelectedElement';


export interface ToggleElementProps {
    label:string;
    selected: boolean;
    onPress: () => void;
  }


export const ToggleElement: FC<ToggleElementProps>= ({label, selected, onPress} : ToggleElementProps) => {
  if(selected) {
    return <ToggleSelectedElement label={label} onPress={onPress} />;
  } else {
    return <ToggleNotSelectedElement label={label} onPress={onPress} />;
  }
};




